var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tile.isVisible ? _c('div', {
    staticClass: "w-full h-full p-0.5"
  }, [_c('button', {
    class: `
       w-full h-full flex items-center justify-center text-2xl sm:text-3xl rounded-lg shadow-lg transition-all duration-200
       ${_vm.isSelected ? 'bg-indigo-500 scale-105 shadow-indigo-500/50' : 'bg-slate-800 hover:bg-slate-700'}
       ${_vm.isHinted ? 'ring-4 ring-yellow-400 animate-pulse' : 'ring-1 ring-slate-700'}
       active:scale-95 tile-enter
     `,
    on: {
      "click": function ($event) {
        return _vm.handleClick(_vm.tile);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.iconSet[_vm.tile.type]) + " ")])]) : _c('div', {
    staticClass: "full h-full p-1"
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };